var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSummaryEndLoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 22,
    fill: "#E3E3E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -555.5,
    y: -258.5,
    width: 1207,
    height: 600,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Variant2",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Location"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 426",
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -234,
    y: -11,
    width: 262,
    height: 62,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -234.5,
    y: -11.5,
    width: 263,
    height: 63,
    rx: 10.5,
    stroke: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "geo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "v2 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.375C4.72183 1.375 2.875 3.22183 2.875 5.5C2.875 7.77817 4.72183 9.625 7 9.625C9.27817 9.625 11.125 7.77817 11.125 5.5C11.125 3.22183 9.27817 1.375 7 1.375ZM1.5 5.5C1.5 2.46243 3.96243 0 7 0C10.0376 0 12.5 2.46243 12.5 5.5C12.5 8.30474 10.4006 10.6191 7.6875 10.9574V18.5625C7.6875 18.9422 7.3797 19.25 7 19.25C6.6203 19.25 6.3125 18.9422 6.3125 18.5625V10.9574C3.59941 10.6191 1.5 8.30474 1.5 5.5ZM4.92826 17.2896C4.99031 17.6642 4.73695 18.0181 4.36235 18.0802C3.38411 18.2422 2.60354 18.4853 2.08771 18.7571C1.82947 18.8932 1.66803 19.0206 1.57863 19.1219C1.53573 19.1706 1.51592 19.2058 1.50725 19.2258C1.50301 19.2356 1.50134 19.2418 1.50068 19.2449C1.50004 19.2479 1.5 19.25 1.5 19.25C1.5 19.25 1.49993 19.2534 1.5021 19.2605C1.50443 19.2682 1.51019 19.2833 1.52411 19.306C1.55329 19.3536 1.6128 19.425 1.72429 19.5129C1.95129 19.6918 2.32236 19.8829 2.84218 20.0562C3.87464 20.4004 5.3447 20.625 7 20.625C8.6553 20.625 10.1254 20.4004 11.1578 20.0562C11.6776 19.8829 12.0487 19.6918 12.2757 19.5129C12.3872 19.425 12.4467 19.3536 12.4759 19.306C12.4898 19.2833 12.4956 19.2682 12.4979 19.2605C12.5 19.2536 12.5 19.2501 12.5 19.2501C12.5 19.2501 12.5 19.2479 12.4993 19.2449C12.4987 19.2418 12.497 19.2356 12.4928 19.2258C12.4841 19.2058 12.4643 19.1706 12.4214 19.1219C12.332 19.0206 12.1705 18.8932 11.9123 18.7571C11.3965 18.4853 10.6159 18.2422 9.63765 18.0802C9.26305 18.0181 9.00969 17.6642 9.07174 17.2896C9.13379 16.915 9.48776 16.6616 9.86235 16.7237C10.9215 16.8991 11.8597 17.1752 12.5532 17.5406C13.1887 17.8755 13.875 18.427 13.875 19.25C13.875 19.8357 13.5183 20.2843 13.1268 20.5928C12.7276 20.9074 12.1925 21.1607 11.5926 21.3607C10.3857 21.763 8.76196 22 7 22C5.23804 22 3.61435 21.763 2.40737 21.3607C1.80748 21.1607 1.27241 20.9074 0.8732 20.5928C0.481739 20.2843 0.125 19.8357 0.125 19.25C0.125 18.427 0.811289 17.8755 1.44676 17.5406C2.14034 17.1752 3.07853 16.8991 4.13765 16.7237C4.51224 16.6616 4.86621 16.915 4.92826 17.2896Z",
    fill: "#005182"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -240,
    y: -17,
    width: 274,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 561,
    fill: "white",
    transform: "translate(-234 -239)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryEndLoc);
export default __webpack_public_path__ + "static/media/summary-end-loc.d7801c6bbff458a29f87ac3a0ded25a7.svg";
export { ForwardRef as ReactComponent };